module.exports = __webpack_public_path__ + "static/media/SKODA_logo1_white.fb697a53.png";